import { memo } from 'react'
import { NodeProps, useReactFlow } from 'reactflow'
import { useShallow } from 'zustand/react/shallow'

import { NodeTypeEnum, PanelEnum } from '@ui/interfaces'
import { FeatureFlagName, useFeatureFlag } from '@ui/providers/FeatureFlagProvider'
import { useNodeAndEdgeStore } from '@ui/stores'
import { useLayoutPanelManagerStore } from '@ui/stores/pipelinesWorkflow'

import { LayoutPanel, RIGHT_PANEL_CONTENT } from '../PipelineLayoutManager'
import { NodeContainer } from './NodeContainer'
import { NodeContainerV2 } from './NodeContainerV2'

export const PlaceholderNode = memo((node: NodeProps) => {
  const workflowUpdateEnabled = useFeatureFlag(FeatureFlagName.WorkflowUpdate)

  const { fitView } = useReactFlow()

  const { currentNodeId, setDisplayModal, nodes } = useNodeAndEdgeStore(
    useShallow((state) => ({
      currentNodeId: state.currentNodeId,
      setDisplayModal: state.setDisplayModal,
      nodes: state.nodes,
    }))
  )

  const { setPanelContent } = useLayoutPanelManagerStore(
    useShallow((state) => ({
      setPanelContent: state.setPanelContent,
    }))
  )

  const { setCurrentNodeId } = useNodeAndEdgeStore(
    useShallow((state) => ({
      setCurrentNodeId: state.setCurrentNodeId,
    }))
  )

  const onClick = () => {
    if (workflowUpdateEnabled) {
      setCurrentNodeId(node.id)

      const currentNode = nodes.find((n) => n.id === node.id)
      fitView({ nodes: [currentNode!], duration: 400, maxZoom: 1.5, padding: 0.5 })

      setPanelContent({
        panel: LayoutPanel.RIGHT_PANEL,
        content: RIGHT_PANEL_CONTENT.ADD_NODE,
        open: true,
      })
    } else {
      setCurrentNodeId(node.id)
      setDisplayModal(PanelEnum.ADD_STEP)
    }
  }

  if (workflowUpdateEnabled) {
    return (
      <NodeContainerV2
        nodeIsSelected={currentNodeId === node.id}
        nodeType={NodeTypeEnum.PLACEHOLDER}
        node={node}
        onClick={onClick}
      />
    )
  }

  return (
    <NodeContainer
      nodeIsSelected={currentNodeId === node.id}
      nodeType={NodeTypeEnum.PLACEHOLDER}
      node={node}
      onClick={onClick}
    />
  )
})
